import { styled, Box } from '@mui/material';

export const AccountFieldsContainer = styled(Box)(({ theme }) => ({
  padding: '2rem',
  background: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,

  '& label': {
    paddingTop: 0,
  },
}));
